
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 0a2.5 2.5 0 012.5 2.5v1.188C29.611 4.77 35.231 10.39 36.312 17.5H37.5a2.5 2.5 0 110 5h-1.188c-1.081 7.111-6.7 12.73-13.811 13.812L22.5 37.5a2.5 2.5 0 11-5 0v-1.188c-7.11-1.08-12.73-6.7-13.812-13.812H2.5a2.5 2.5 0 110-5h1.188c1.08-7.11 6.702-12.73 13.813-13.812L17.5 2.5A2.5 2.5 0 0120 0zm0 8.5C13.649 8.5 8.5 13.649 8.5 20S13.649 31.5 20 31.5 31.5 26.351 31.5 20 26.351 8.5 20 8.5zm0 4.5a7 7 0 110 14 7 7 0 010-14z"}})])
          )
        }
      }
    